// Generated from src/img/svg/busev.svg

export const Busev = (props) => {
  return (
    <svg fill="none" height="150" viewBox="0 0 132 132" width="150" {...props}>
      <g transform="matrix(.95 0 0 .95 6.65 7.6)">
        <circle
          cx="66"
          cy="66"
          fill="#F9AF42"
          r="62.552"
          stroke="#9B1B60"
          strokeWidth="6.896"
        />
        <path
          d="M27.08 47.585v12.243c0 2.799 4.08 3.498 5.247 3.498v33.231c0 4.898 3.498 6.705 5.247 6.996v3.498c.291 1.749.35 5.248 5.247 5.248s6.121-3.499 6.121-5.248c12.03-.291 36.042-.699 35.855 0-.234.875 0 5.248 5.247 5.248 4.198 0 5.247-2.333 5.247-3.499v-5.247c4.198 0 5.247-4.664 5.247-6.996v-33.23c4.198 0 5.247-2.333 5.247-3.499V47.585c0-2.798-3.498-4.372-5.247-4.372v-7.87c0-6.297-5.83-8.455-8.745-8.746H41.946c-6.996 0-9.328 5.83-9.62 8.745v7.87c-4.197 0-5.247 2.916-5.247 4.373Z"
          fill="#9B1B60"
          stroke="#9B1B60"
          strokeWidth="1.749"
        />
        <path
          d="M39.323 81.69V44.088h55.093v37.604c-25.885 2.798-47.514 1.166-55.093 0"
          fill="#F9AF42"
        />
        <circle cx="46.319" cy="94.808" fill="#F9AF42" r="5.247" />
        <circle cx="88.295" cy="94.808" fill="#F9AF42" r="5.247" />
      </g>
    </svg>
  );
};
